import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IntlPhoneNumberComponent } from '../../../intl-phone-number/intl-phone-number.component';
import { EditService, OrdersService, TrackingInfo } from '@evermile/customer-tracking';
import { firstValueFrom, forkJoin, lastValueFrom } from 'rxjs';
import { ValidationsService } from '@evermile/customer-tracking';
import { take } from 'rxjs/operators';
import { EditOrderService } from '../../../services/edit-order.service';
import { EditOrderContactUsButtonComponent } from '../edit-order-contact-us-button/edit-order-contact-us-button.component';

@Component({
  selector: 'common-recipient-details-form',
  templateUrl: './recipient-details-form.component.html',
  styleUrls: ['./recipient-details-form.component.scss'],
})
export class RecipientDetailsFormComponent implements OnInit {
  @Input() order!: TrackingInfo | any;
  @Input() index!: number;
  @Input() brandColor?: string;
  @Input() textColor?: string;
  form!: FormGroup;
  loading = false;
  displayErrors = false;
  emailError?: string;
  phoneError?: string;

  //Subscription
  constructor(
    private fb: FormBuilder,
    private apiValidationService: ValidationsService,
    private editOrderService: EditOrderService,
  ) {}

  ngOnInit() {
    this.setForm();
  }

  setForm() {
    this.form = this.fb.group({
      name: new FormControl(this.order?.customerName || '', Validators.required),
      email: new FormControl(this.order?.['customerEmail'] || undefined, [Validators.email]),
      phoneNumber: (this.form = this.fb.group({
        phone: new FormControl(this.order?.['customerPhone'] || '', Validators.required),
      })),
    });
    this.form.valueChanges.subscribe((data) => {
      this.form.markAllAsTouched();
      this.resetErrors();
    });
  }

  resetErrors() {
    this.phoneError = '';
    this.emailError = '';
  }

  confirm(event: any) {
    this.loading = true;
    this.validateForm();
    if (this.form.invalid) {
      this.displayErrors = true;
      this.loading = false;
      return;
    }
    this.editOrderService.submitEditOrder({
      dropoffContactDetails: {
        contactName: this.form.value.name,
        contactEmail: this.form.value.email || undefined,
        contactPhone: this.form.value.phoneNumber.phone,
        instructions: this.order.instructions,
        customerInstructions: this.order.customerInstructions,
      },
    });
  }

  async validateForm() {
    if (this.form.get('email')?.hasError('email')) {
      this.emailError = 'Invalid email';
    }
    if (this.form.get('phoneNumber')?.invalid) {
      this.phoneError = 'Invalid phone number';
    }
    if (this.form.get('email')?.value) {
      try {
        const emailValidation$ = this.apiValidationService
          .validateEmailGet(this.form.get('email')?.value)
          .pipe(take(1));
        await lastValueFrom(emailValidation$);
      } catch (e) {
        this.emailError = 'Invalid email';
      }
    }
    try {
      const phoneValidation$ = this.apiValidationService
        .validatePhoneGet(this.form.get('phoneNumber')?.value.phone)
        .pipe(take(1));
      await lastValueFrom(phoneValidation$);
    } catch (e) {
      this.phoneError = 'Invalid phone number';
    }
  }
}
